<div class="nav-left-sidebar sidebar-dark  {{isExpanded? 'closed' : 'opened'}}">
  <div class="admin-logo">
    <div class="full">
      <img src="assets/images/logo-white.png" class="img-fluid" alt="" />
    </div>
    <div class="icon">
      <img src="assets/images/logo-icon.png" class="img-fluid" alt="" />
    </div>
  </div>
  <div class="menu-list">
    <nav class="navbar">
      <!-- <a class="d-xl-none d-lg-none" href="#">Dashboard</a> -->

        <ul class="navbar-nav flex-column">
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/dashboard">
              <i class="material-symbols-sharp">dashboard</i>Dashboard
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" (click)="toggleCollapse()" [ngClass]="{'closed': !isSubMenuVisible, 'open': isSubMenuVisible}"><i class="material-symbols-sharp">restaurant_menu</i>Restaurant <mat-icon class="ml-auto">arrow_right</mat-icon></a>
            <div id="submenu-3"  [ngClass]="{'collapse': !isSubMenuVisible, 'show': isSubMenuVisible}" class="submenu">
              <ul class="nav flex-column">
                <li class="nav-item" routerLinkActive="active">
                  <a class="nav-link" routerLink="/add-restaurant-info">
                    Restaurant Information
                  </a>
                </li>
                <li class="nav-item" routerLinkActive="active" *ngIf="isRestaurantInfoSubmitted">
                  <a class="nav-link" routerLink="/add-restaurant-operational-hours">
                    Restaurant Type and Timings
                  </a>
                </li>
                <li class="nav-item" routerLinkActive="active" *ngIf="isRestaurantInfoSubmitted">
                  <a class="nav-link" routerLink="/restaurant-slot">
                    Slot Management
                  </a>
                </li>
                <li class="nav-item" routerLinkActive="active" *ngIf="isRestaurantInfoSubmitted">
                  <a class="nav-link" routerLink="/add-restaurant-menu/{{id}}">
                    Upload Menu Images
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/review-list">
              <i class="material-symbols-sharp">reviews</i>Customer Reviews
            </a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/booking-list">
              <i class="material-symbols-sharp">event_seat</i>Reservations
            </a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/restro-policy">
              <i class="material-symbols-sharp">policy</i>Restaurant Policy
            </a>
          </li>
          <li class="nav-item" routerLinkActive="active">
            <a class="nav-link" routerLink="/contact-us">
              <i class="material-symbols-sharp">person</i>Contact Us
            </a>
          </li>
        </ul>
    </nav>
  </div>
</div>